import { render, staticRenderFns } from "./rightBox.vue?vue&type=template&id=5c61b4c6&scoped=true&"
import script from "./rightBox.vue?vue&type=script&lang=js&"
export * from "./rightBox.vue?vue&type=script&lang=js&"
import style0 from "./rightBox.vue?vue&type=style&index=0&id=5c61b4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c61b4c6",
  null
  
)

export default component.exports